import { Component, Input } from '@angular/core';
import { BaseCondition } from '../models/base-condition.model';
import { Condition } from '../models/condition.model';

@Component({
  selector: 'condition-container',
  templateUrl: 'condition-container.html',
})
export class ConditionContainerComponent {
  @Input() conditionModel: BaseCondition;

  isSingleCondition(): boolean {
    return this.conditionModel instanceof Condition;
  }

  isOrCondition(): boolean {
    return this.conditionModel instanceof Condition;
  }

  isAndCondition(): boolean {
    return this.conditionModel instanceof Condition;
  }

}

